import { localStorage, sessionStorage } from 'dibs-browser-storage';
import { getBuyerId } from 'dibs-cookie-jar';
import SV from 'server-vars';

import isPageType from '../../../utils/isPageType';
import { PAGE_TYPE } from '../../../utils/pageConstants';
import { MODAL_ID, NUM_TIMES_TO_SHOW } from './constants';

import { fetchQuery, graphql } from 'react-relay';
import getter from 'dibs-object-getter';

const ELIGIBLE = 'ELIGIBLE';
const NOT_ELIGIBLE = 'NOT_ELIGIBLE';

const query = graphql`
    query tradeProgramAnnouncementModalRule_Query($userId: String!) {
        viewer {
            isProgramAnnouncementDisabled: isEnabled(
                key: "disable2019TradeProgramAnnouncementModal"
            )
            user(userId: $userId) {
                tradeFirm {
                    rewards {
                        currentProgram {
                            programInfo {
                                code
                            }
                        }
                    }
                }
            }
        }
    }
`;

function hasSeenModal() {
    if (sessionStorage && localStorage) {
        const modalStorage = localStorage.getItem(MODAL_ID) || {};
        return (
            !!sessionStorage.getItem(MODAL_ID) || modalStorage.totalViewCount >= NUM_TIMES_TO_SHOW
        );
    }
    return false;
}

function markModalSeen() {
    if (sessionStorage) {
        sessionStorage.setItem(MODAL_ID, true);
    }
    if (localStorage) {
        let modalStorage = localStorage.getItem(MODAL_ID);
        if (modalStorage) {
            modalStorage.totalViewCount++;
        } else {
            modalStorage = {
                totalViewCount: 1,
            };
        }
        localStorage.setItem(MODAL_ID, modalStorage);
    }
}
function queryIsEnrolled(userId, relayEnvironment) {
    return fetchQuery(relayEnvironment, query, { userId }).then(data => {
        const isDisabled = getter(data)
            .at('viewer')
            .value('isProgramAnnouncementDisabled');
        const currentProgram =
            getter(data)
                .at('viewer')
                .at('user')
                .at('tradeFirm')
                .at('rewards')
                .at('currentProgram')
                .at('programInfo')
                .value('code') || null;

        const shouldOpenModal =
            !isDisabled &&
            currentProgram &&
            currentProgram !== ELIGIBLE &&
            currentProgram !== NOT_ELIGIBLE;
        if (shouldOpenModal) {
            markModalSeen();
        }

        return shouldOpenModal;
    });
}

export function tradeProgramAnnouncementModalRule({ relayEnvironment }) {
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    const isMobile = SV.get('settings.isMobile') || false;
    const isBlacklistedPage = isPageType([
        PAGE_TYPE.CHECKOUT,
        PAGE_TYPE.CHECKOUT_CONFIRMATION,
        PAGE_TYPE.ORDER_MANAGER,
        PAGE_TYPE.TRADE_REWARDS,
    ]);
    if (!isUserTypeTrade || isMobile || isBlacklistedPage || hasSeenModal()) {
        return Promise.resolve(false);
    }

    const userId = getBuyerId(document.cookie);
    return queryIsEnrolled(userId, relayEnvironment);
}
